import { ShareIcon } from "@/Icons/Share";

import React from "react";
import { Link } from "react-router-dom";

type Props = {
  link: string;
};

export const ShareLink: React.FC<Props> = ({ link }: Props) => {
  return (
    <Link className="ml-2 underline" to={link} target="_blank">
      <ShareIcon width={10} height={10} />
    </Link>
  );
};
